import { CATALOGS, geraetesprache, useLocaleStore, type Locale } from '../i18n';

/**
 * Welche Sprache die Oberfläche zeigt — `language` und `language_changeable` zusammen.
 *
 * Entscheidungen der Nutzer vom 2026-10-01 (Relay-Seite und Stage-Seite):
 *
 * - **`language` gilt für die ganze App**, nicht nur während einer Prüfung. `system` heisst:
 *   die Sprache des iPads.
 * - **`language_changeable = true`:** der Prüfer darf jederzeit umstellen — im
 *   Einstellungsdialog, wie bisher. Seine Wahl gilt **dauerhaft**, auch nach einem Neustart.
 *   Anders als bei Ink: dort sitzt jedes Mal ein anderer Prüfling vor dem Gerät, hier derselbe
 *   Prüfer den ganzen Tag.
 * - **`language_changeable = false`:** kein Wähler, es gilt allein `language`.
 * - **Kippt der Schalter mitten in einer Prüfung auf `false`,** bleibt die gewählte Sprache bis
 *   zum Ende der Prüfung — das ist die Rückkehr zur Prüfungsauswahl. Danach wird die Wahl
 *   vergessen. Weil sie gespeichert ist, überlebt sie auch einen Neustart mitten in der Prüfung.
 */

export type Sprachentscheid = 'eigene' | 'behalten' | 'vorgabe';

export function sprachentscheid(lage: { waehlbar: boolean; gewaehlt: boolean; pruefungLaeuft: boolean }): Sprachentscheid {
  if (!lage.gewaehlt) return 'vorgabe';
  if (lage.waehlbar) return 'eigene';
  return lage.pruefungLaeuft ? 'behalten' : 'vorgabe';
}

/**
 * Setzt die Sprache nach `sprachentscheid`. Wartet nicht auf `init` des Sprachspeichers — vor
 * dessen Ende ist `chosen` nicht verlässlich; der Aufrufer ruft erneut, sobald `geladen` steht.
 */
export async function stimmeSpracheAb(lage: {
  sprache: Locale | 'system';
  waehlbar: boolean;
  pruefungLaeuft: boolean;
}): Promise<void> {
  const speicher = useLocaleStore.getState();
  if (!speicher.geladen) return;

  const entscheid = sprachentscheid({ ...lage, gewaehlt: speicher.chosen });
  if (entscheid !== 'vorgabe') return;

  if (speicher.chosen) speicher.vergissWahl();
  const ziel = lage.sprache === 'system' ? await geraetesprache() : lage.sprache;
  if (ziel !== useLocaleStore.getState().locale || CATALOGS[ziel] !== useLocaleStore.getState().t) {
    useLocaleStore.getState().setzeVorgabe(ziel);
  }
}
